/**
 * Format panel transcript plain text for line-by-line dialogue display.
 * Handles both pre-wrapped VTT output and single-paragraph manual uploads.
 */

/** Full speaker label, e.g. ``Pinky Mondal: `` */
const SPEAKER_LABEL_RE = /([A-Z][a-z]+(?: [A-Z][a-z]+)*): /g;

function splitSpeakerParagraph(text) {
  const matches = [...text.matchAll(SPEAKER_LABEL_RE)];
  if (matches.length <= 1) {
    const trimmed = text.trim();
    return trimmed ? [trimmed] : [];
  }
  return matches.map((m, i) => {
    const start = m.index ?? 0;
    const end = i + 1 < matches.length ? (matches[i + 1].index ?? text.length) : text.length;
    return text.slice(start, end).trim();
  }).filter(Boolean);
}

export function splitPanelTranscriptLines(text) {
  const trimmed = (text || '').trim();
  if (!trimmed) return [];

  const byNewline = trimmed.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  if (byNewline.length > 1) return byNewline;

  return splitSpeakerParagraph(trimmed);
}

/** @returns {{ speaker: string|null, message: string, raw: string }} */
export function parseSpeakerLine(line) {
  const raw = (line || '').trim();
  const idx = raw.indexOf(':');
  if (idx <= 0) return { speaker: null, message: raw, raw };
  const speaker = raw.slice(0, idx).trim();
  const message = raw.slice(idx + 1).trim();
  if (!speaker || !/^[A-Za-z]/.test(speaker)) {
    return { speaker: null, message: raw, raw };
  }
  return { speaker, message, raw };
}
